import React, { FC, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { LegislationCard } from './LegislationCard';
import { PopoverWrapper } from '../../components/popovers/wrapper/PopoverWrapper';
import { PopoverLoading } from '../../components/popovers/loading/PopoverLoading';

import { delayPromise } from '../../utils/promise';
import { getLegislationFromArticleId } from '../legislation.api';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { LegislationPopoverInfos } from '../legislation.types';

type Props = {
  articleId: string;
  source: string;
  target?: '_blank';
};

export const LegislationPopover: FC<Props> = ({
  articleId,
  source,
  target,
}) => {
  const [
    legislationInfos,
    setLegislationInfos,
  ] = useState<LegislationPopoverInfos | null>(null);
  const [isLoading, setLoading] = useState(false);
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const query = searchParams.get('q');

  useEffect(() => {
    async function fetch() {
      setLoading(true);

      const data = await delayPromise(
        getLegislationFromArticleId(articleId),
        300,
      );
      doctrineAnalytics('DisplayLawPopover');
      setLegislationInfos({ ...data, articleId });
      setLoading(false);
    }

    fetch();
  }, [articleId]);

  if (isLoading)
    return (
      <PopoverWrapper>
        <PopoverLoading />
      </PopoverWrapper>
    );

  if (!legislationInfos) return null;

  let url;
  if (query) {
    url = legislationInfos.url.includes('?')
      ? `${legislationInfos.url}&q=${query}`
      : `${legislationInfos.url}?q=${query}`;
  } else {
    // eslint-disable-next-line prefer-destructuring
    url = legislationInfos.url;
  }

  return (
    <PopoverWrapper>
      <LegislationCard
        legislation={legislationInfos}
        source={source}
        target={target}
        url={url}
      />
    </PopoverWrapper>
  );
};
